var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBackIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 3L5.02344 5.88675V0.113249L0.0234375 3ZM7.52344 11.5C7.24729 11.5 7.02344 11.7239 7.02344 12C7.02344 12.2761 7.24729 12.5 7.52344 12.5V11.5ZM4.52344 3.5H9.52344V2.5H4.52344V3.5ZM9.52344 11.5H7.52344V12.5H9.52344V11.5ZM13.5234 7.5C13.5234 9.70914 11.7326 11.5 9.52344 11.5V12.5C12.2849 12.5 14.5234 10.2614 14.5234 7.5H13.5234ZM9.52344 3.5C11.7326 3.5 13.5234 5.29086 13.5234 7.5H14.5234C14.5234 4.73858 12.2849 2.5 9.52344 2.5V3.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIconActive);
export default __webpack_public_path__ + "static/media/go-back-icon-active.941be759f15a4f5b9e3ef04117834008.svg";
export { ForwardRef as ReactComponent };